const ImportHelper = {
    importAll(r: any){
        let images: Array<string> = [];
        r.keys().map((item: string, index: number) => {images[index] = r(item).default});
        return images
    }
}

export default ImportHelper